import React from 'react';
import cs from 'classnames';
import isEmpty from 'lodash/isEmpty';
import {connect} from 'react-redux';
import {push as changeURL} from 'react-router-redux';

import EndingPage from '../EndingPage';
import mapDispatch from '~/misc/mapDispatch';
import Spinner from '~/components/common/Spinner';
import {track} from '~/misc/metrics';
import {getUrlQeury} from '~/misc/formatUrlquery';
import css from './index.css';
import sharedCSS from '~/components/shared.css';
import accountPageCss from '../MyAccount/share.css';

class Result extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      info: isEmpty(this.props.hp.pay.data) ? this.props.hp.paymentInfo.data[0] : this.props.hp.pay.data,
    };
  }
  componentWillMount() {
    const query = getUrlQeury();
    // track('payment', {'pay successful': 1, source: query.source || "Normal", membership: query.level, biilling_cycle: query.cycle});
    const token = this.props.user.token;
    
    if (!token || (isEmpty(this.props.hp.pay.data) && isEmpty(this.props.hp.paymentInfo.data))) {
      this.props.gotoRoot();
    }
  }
  componentWillReceiveProps(nextProps) {
    if (isEmpty(this.props.hp.pay.data) && !isEmpty(nextProps.hp.pay.data)) {
      this.setState({
        info: this.props.hp.pay.data,
      });
    }
    // 解决当前页面登出后数据不更新的问题，
    if (this.props.user.id && (this.props.user.id !== nextProps.user.id)) {
      this.props.gotoRoot();
    }
  }
  render() {
    if (isEmpty(this.state.info)) {
      return (
        <div className={sharedCSS.viewH}>
          <div className={cs(accountPageCss.spinnerLine)}>
            <div className={cs(accountPageCss.spinner, css.marginCenter)}>
              <Spinner scalable={true}/>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className={cs(sharedCSS.widewrap, 'qa-content')}>
        <div className={cs(sharedCSS.wideStretchable, css.wrap)}>
          <div className={cs(css.content)}>
            <EndingPage user={this.props.user} account={this.props.account} orderInfo={this.state.info} type='result'/>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(({user, routing, account, hp}) => ({user, routing, account, hp}), mapDispatch({
  gotoRoot: () => changeURL('/'),
}))(Result);



// WEBPACK FOOTER //
// ./src/components/pages/Result/index.js